import { red, blue, purple, pink, lightGreen, lime, amber, teal, brown } from 'material-ui/colors'

let mainChartColors = [
  lightGreen[400],
  lime[400],
  purple[400],
  amber[400],
  brown[200],
  teal[400]
]

let statusColors = {
  complete: mainChartColors[0],
  started_onschedule: mainChartColors[1],
  started_behindschedule: mainChartColors[2],
  notstarted_onschedule: mainChartColors[3],
  notstarted_behindschedule: mainChartColors[4]
}

let criticalColors = {
  critical: red[400],
  non_critical: blue[400]
}

let costColors = {
  fixed: pink[400],
  resource: purple[400]
}


let percentageColors = (palette) => (
  [palette[400], palette[50]]
)

let chartColors = {
  primary: mainChartColors,
  critical: criticalColors,
  status: statusColors,
  health: percentageColors(purple),
  project_status: percentageColors(lime),
  cost: costColors

}

let chartSizes = {
  radius: {
    small: 90,
    large: 140
  },
  width: {
    small: 320,
    large: '100%'
  },
  height: {
    small: 180,
    large: ''
  }
}

let typography = {
  tagline : {
    type: 'body2',
    style: {
      textAlign: 'center',
      marginTop: 8
    }
  }
}

let chartSelection = {
  strokeWidth: 2,
  strokeColor: blue[800]
}

let framework = {
  drawerWidth: 320,
  dashboardsWidth: 960,
  singleDashboardWidth: 710,
  typography
}



export {chartColors, chartSizes, percentageColors, framework, chartSelection}


// WEBPACK FOOTER //
// ./src/etc/theme.js